import clsx from "clsx";
import { cva, type VariantProps } from "cva";
import { HTMLAttributes, PropsWithChildren } from "react";

import styles from "./index.module.css";

const variants = cva({
  base: styles.base,
  variants: {
    variant: {
      info: styles.info,
      weak: styles.weak,
      custom: styles.custom,
      success: styles.success,
      notice: styles.notice,
      caution: styles.caution,
      disabled: styles.disabled,
      invariable: styles.invariable,
    },
  },
  defaultVariants: {
    variant: "info",
  },
});

export type Variant = NonNullable<VariantProps<typeof variants>["variant"]>;

export type TextProps = PropsWithChildren<
  Omit<HTMLAttributes<HTMLParagraphElement>, "children"> & VariantProps<typeof variants>
>;

export const Text = ({ children, className, variant, ...props }: TextProps) => (
  <p className={clsx(variants({ variant }), className)} {...props}>
    {children}
  </p>
);
